import React from "react";
import Components from "mpm-components";
import Services from "mpm-services";
import { Button, Icon, Divider, Step } from "semantic-ui-react";
import moment from "moment";
import StepDetails from "./sections/StepDetails";
import StepSources from "./sections/StepSources";
import StepRecap from "./sections/StepRecap";
import CessionCapture from "mpm-classes/CessionCapture";
import * as Constants from "mpm-config/Constants";
import { toClass } from "class-converter";
const initalCessionCapture = {
  listSources: undefined,

  id: undefined,
  numeroCession: undefined,
  numeroCessionComplet: undefined,
  dateCession: "",
  dateSysteme: moment().format("DD/MM/YYYY"),
  etat: undefined,
  typeCedant: undefined,
  typeAcquereur: undefined,
  auditLabelDesc: undefined,
  refCedantArm: undefined,
  refCedantMar: undefined,
  acquereurCCDTO: {
    id: undefined,
    success: false,
    message: undefined,
    typeAcquereur: undefined,
    numeroAcquereur: "",
    nom: undefined,
    prenom: undefined,
    raisonSocialeFR: undefined,
    id_refMar: undefined,
    id_refUsi: undefined,
    id_refExp: undefined,
  },
  childrenSourceCC: [],
};
export default ({ selectedCessionCaptureId, onComplet, setMessage }) => {
  const [cessionCapture, setCessionCapture] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [isError, setIsError] = React.useState(false);
  const [step, setStep] = React.useState(1);
  const [saving, setSaving] = React.useState(false);
  const [validating, setValidating] = React.useState(false);
  const [editMode, setEditMode] = React.useState(false);
  React.useEffect(() => {
    if (!selectedCessionCaptureId) {
      const cession = toClass(initalCessionCapture, CessionCapture);
      setCessionCapture(cession);
      setLoading(false);
      setEditMode(false);
    } else {
      setEditMode(true);
      Services.CessionsCaptureDataService.getForEdit(selectedCessionCaptureId)
        .then((response) => {
          setCessionCapture(toClass(response.data, CessionCapture));
          setLoading(false);
          setIsError(false);
        })
        .catch((err) => {
          setIsError(true);
          setLoading(false);
        });
    }
  }, [selectedCessionCaptureId]);

  const onClickNext = () => {
    if (step === 1 && cessionCapture.dateCession === "") {
      setMessage({
        warning: true,
        header: "Validation",
        content: "Date Cession est obligatoire",
      });
      return;
    }
    if (step === 1 && !cessionCapture.acquereurCCDTO.id) {
      setMessage({
        warning: true,
        header: "Validation",
        content: "Merci de charger l'acquereur!",
      });
      return;
    }

    if (step === 2) {
      let isValid = false;
      cessionCapture.childrenSourceCC &&
        cessionCapture.childrenSourceCC.forEach((element) => {
          if (element.sourceCCList && element.sourceCCList.length > 0) {
            isValid = true;
          }
        });

      if (!isValid) {
        setMessage({
          warning: true,
          header: "Validation",
          content: "Source obligatoire!",
        });
        return;
      }
    }

    setStep(step + 1);
    setMessage(null);
  };
  const onClickPrevious = () => {
    setStep(step - 1);
    setMessage(null);
  };

  const onSaveCessionCapture = () => {
    setSaving(true);
    let toBeSaved = toClass(
      {
        ...cessionCapture,
        childrenSourceCC: cessionCapture.childrenSourceCC?.sort((a, b) =>
          !a.id ? 0 : !b.id ? -1 : a.id > b.id ? 1 : a.id < b.id ? -1 : 0
        ),
      },
      CessionCapture
    );
    Services.CessionsCaptureDataService.create(toBeSaved)
      .then((result) => {
        if (result.success) {
          setCessionCapture({ ...cessionCapture, ...result.data });
          setSaving(false);
          setMessage({
            success: true,
            header: "Enregistrement Cession Capture",
            content: "Votre cession de capture a été enregistré avec succée!",
          });
        } else {
          setMessage({
            error: true,
            header: "Enregistrement Cession Capture",
            content: result.message,
          });
          setSaving(false);
        }
      })
      .catch((error) => {
        setMessage({
          error: true,
          header: "Enregistrement Cession Capture",
          content:
            "Une erreur est survenue lors d'enregistrement de cession de capture",
        });
        setSaving(false);
      });
  };

  const onValidateCessionCapture = () => {
    let data = {
      ...cessionCapture,
    };
    setValidating(true);
    Services.CessionsCaptureDataService.validate(data)
      .then((result) => {
        if (result.success) {
          setCessionCapture({ ...cessionCapture, etat: result.data.etat });
          setMessage({
            success: true,
            header: "Validation Cession Capture",
            content: "Votre cession de capture a été validé avec succée",
          });
          setValidating(false);
          onComplet(true);
        } else {
          setMessage({
            error: true,
            header: "Validation Cession Capture",
            content: result.message,
          });
          setValidating(false);
        }

        //
      })
      .catch((error) => {
        setMessage({
          error: true,
          header: "Validation Cession Capture",
          content:
            "Une erreur est survenue lors de validation de cession de capture",
        });
        setValidating(false);
      });
  };

  const isDisabledButtonNext = () => {
    return (
      step === 3 ||
      (cessionCapture.acquereurCCDTO && !cessionCapture.acquereurCCDTO.id)
    );
  };

  return loading ? (
    <Components.MPMLoader
      message="chargement en cours, veuillez patienter !"
      hideLogo
    />
  ) : isError ? (
    <Components.MPMError />
  ) : (
    <>
      <Step.Group ordered fluid size="small" unstackable={true}>
        <Step active={step === 1} completed={step > 1} disabled={step < 1}>
          <Step.Content>
            <Step.Title>Cession Capture</Step.Title>
          </Step.Content>
        </Step>
        <Step active={step === 2} completed={step > 2} disabled={step < 2}>
          <Step.Content>
            <Step.Title>Sources - Especes</Step.Title>
          </Step.Content>
        </Step>
        <Step active={step === 3} completed={step > 3} disabled={step < 3}>
          <Step.Content>
            <Step.Title>Validation</Step.Title>
          </Step.Content>
        </Step>
      </Step.Group>
      {step === 1 && (
        <StepDetails
          editMode={editMode}
          cessionCapture={cessionCapture}
          setMessage={(data) => setMessage(data)}
          onChangeCessionCapture={(cession) => setCessionCapture(cession)}
        />
      )}
      {step === 2 && (
        <StepSources
          editMode={editMode}
          cessionCapture={cessionCapture}
          onComplet={(force) => onComplet(force)}
          setMessage={(data) => setMessage(data)}
          onChangeListSources={(cession) => setCessionCapture(cession)}
        />
      )}
      {step === 3 && (
        <StepRecap
          editMode={editMode}
          cessionCapture={cessionCapture}
          setMessage={(data) => setMessage(data)}
          onChangeCessionCapture={(cession) => setCessionCapture(cession)}
        />
      )}

      <Divider />
      <Button
        icon
        className="full-width"
        labelPosition="left"
        onClick={() => onComplet()}
        size="tiny"
        disabled={saving || validating}
      >
        <Icon name="arrow left" />
        Retour
      </Button>
      {cessionCapture.etat !== Constants.CC_ETAT_VALIDER && (
        <>
          <Button
            icon
            labelPosition="left"
            onClick={() => onSaveCessionCapture()}
            loading={saving}
            primary
            className="full-width"
            size="tiny"
            disabled={step !== 3 || saving || validating}
          >
            <Icon name="save" />
            Enregitrer
          </Button>
          <Button
            icon
            className="full-width"
            labelPosition="left"
            onClick={() => onValidateCessionCapture()}
            loading={validating}
            positive
            size="tiny"
            disabled={step !== 3 || saving || validating}
          >
            <Icon name="check" />
            Valider
          </Button>
        </>
      )}
      <Button
        icon
        className="full-width"
        labelPosition="right"
        onClick={() => onClickNext()}
        disabled={isDisabledButtonNext()}
        size="tiny"
        floated="right"
      >
        <Icon name="chevron right" />
        Suivant
      </Button>
      <Button
        icon
        className="full-width"
        labelPosition="left"
        onClick={() => onClickPrevious()}
        disabled={step === 1 ? true : false}
        size="tiny"
        floated="right"
      >
        <Icon name="chevron left" />
        Précédent
      </Button>
    </>
  );
};
